module.exports = __webpack_public_path__ + "img/November.3561b5d8.png";